import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./styles";

export default class PopoverComponent extends Component {
  render() {
    const { certDetails, certificateName, showPopover } = this.props;
    const finalClassName = "icon-certification-" + certificateName;
    return (
      <span data-testid="component-popOver">
        <style jsx>{style}</style>
        {showPopover &&
        certDetails.length &&
        certDetails[0].certName &&
        certificateName == certDetails[0].certName.toLowerCase() ? (
          <div className="popover-body">
            <div className={`arrow-top`}></div>
            <h4 className="inline-text-certification">
              <i className={finalClassName}></i>
              <div className="popover-title">
                {certDetails && certDetails[0] && certDetails[0].fullForm}
              </div>
            </h4>
            <div className="certDetailWrapper">
              <p className="summaryBlock">
                {certDetails && certDetails[0] && certDetails[0].summary}
              </p>
              <div
                className={
                  certDetails && certDetails[0]
                    ? "select-logo logo-" + certDetails[0].certName.toLowerCase()
                    : "select-logo"
                }></div>
            </div>
          </div>
        ) : null}
      </span>
    );
  }
}

PopoverComponent.defaultProps = {};

PopoverComponent.propTypes = {
  finalClassName: PropTypes.string,
  certDetails: PropTypes.array,
  showPopover: PropTypes.bool,
  certificateName: PropTypes.string,
};
